export default "__VITE_ASSET__4ed566cf__"